import React from 'react';
import {
    List,
} from 'reactstrap';
import { httpClient } from '@s20/services/httpClient';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import {
    AppPageForm, onFieldChange, toasty, Input,
} from '../common/forms/FormElements';
import CustomCircularProgress from '../common/CustomCircularProgress';
import { Block, BlockBorder } from '../common/Block';
import { SaveButton } from '../common/forms/SaveButton';
import { ExecutionHistory } from './common/ExecutionHistory';

class GrantMultiTenantAccessViewModel {
    userName = '';
}

class GrantMultiTenantAccess extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            formValidated: false,
            loading: false,
            saving: false,
            data: new GrantMultiTenantAccessViewModel(),
            isValidated: false,
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange = onFieldChange;

    onSubmit = async () => {
        const { data } = this.state;

        this.setState({ saving: true });

        try {
            await httpClient.post(
                ApiRoutes.adminTool.grantMultiTenantAccess(),
                data,
            );

            this.setState({
                data: new GrantMultiTenantAccessViewModel(),
                isValidated: false,
            });

            toasty.success(`Access has been granted to ${data.userName}`);

            // Refresh the table after successful submission
            await this.props.refreshUsageHistory();
        } catch (err) {
            console.error(err);
            toasty.error(
                'Error: Access grant. Please Check Form Inputs',
            );
            await this.props.refreshUsageHistory();
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        const {
            loading,
            saving,
            isValidated,
            data,
        } = this.state;

        if (loading) {
            return (
                <div className="confirmationContainer pt-2 d-flex flex-row align-items-center justify-content-center">
                    <CustomCircularProgress
                        color="secondary"
                        variant="indeterminate"
                        label={
                            this.props.match.params.id
                                ? 'Getting Tool History...'
                                : 'Loading form...'
                        }
                    />
                </div>
            );
        }

        if (!(this.context ?? {}).user) return null;

        return (
            <AppPageForm
                backUrl={AppNavPaths.AdminTool}
                backLabel="Back to Admin Tools"
                formShown={this.context.formIsOpen}
                formId="adminToolList"
                formName="adminToolList"
                formHeading="Grant Multi-Tenant Access"
                formRef={this.formRef}
                formIsColumn
                saving={saving}
                isValidated={isValidated}
                onSubmit={this.onSubmit}
                setIsValidated={(value) => {
                    this.setState({ isValidated: value });
                }}
            >
                <Block padding="medium">
                    <div>
                        <Input
                            label="User name"
                            id="userName"
                            name="data.userName"
                            placeholder="Full username you wish to grant permission to"
                            onChange={this.onChange}
                            value={data.userName}
                            required
                            error="User name is Required."
                        />

                        <BlockBorder />

                        <div className="d-flex justify-content-center">
                            <SaveButton
                                saving={saving}
                                label="Submit"
                            />
                        </div>
                    </div>
                </Block>

                <ExecutionHistory usageHistory={this.props.usageHistory}>
                    {(record) => (
                        <List type="unstyled">
                            {record.input.userName && (
                                <li>
                                    <strong>User name:</strong>
                                    {' '}
                                    {record.input.userName}
                                </li>
                            )}
                        </List>
                    )}
                </ExecutionHistory>
            </AppPageForm>
        );
    }
}

export default GrantMultiTenantAccess;
